<template>

    <div :key="currentRiddleIndex_n" class="TQ_center TQ_padding_8px" v-if="currentRiddleIndex_n != null">

        <tq-card v-if="server_teamStatus_c && server_currentUserData_c && server_questBody_c"
                 width="100%"
                 class="TQ_maxWidth_700px">

            <tq-riddle-data
                :p_name_s="currentRiddleIndex_n + ''"

                :p_team-status_sub-collection_e="enum_subCollection_teamStatus.MAP_MISSIONS"

                :p_system_lang-code_e="store_system_langCode_ve.val"
                :p_qb_display-lang-code_e="server_questBody_c.cm_qb_getDisplayLangCode_e(store_system_langCode_ve.val)"

                :p_qb_metadata_c="server_questBody_c.qb_metadata_c"
                :p_user-id_uid="server_currentUserData_c.ud_userId_uid"

                :p_qb_riddle_c="server_questBody_c.qb_mapMissions_ac[currentRiddleIndex_n]"
                :p_riddle-status_c="server_ts_riddles_byRiddleId_c[server_questBody_c.qb_mapMissions_ac[currentRiddleIndex_n].qbr_riddleId_n]"

                :p_players-location_by-user-id_c="server_mapPlayerLocation_byUserId_c"
                :p_current-user-location_c="co_currentUserLocation_c"

                :p_clues-left_n="server_teamStatus_c.ts_cluesLeft_n"
                :p_skips-left_n="server_teamStatus_c.ts_skipsLeft_n"
                :p_cards-mode_b="true"

                :pe_click-image_f="m_clickImg_f"
                :pe_start-watch-position_f="pe_startWatchPosition_f"
                :pe_stop-watch-position_f="pe_stopWatchPosition_f"
                :p_click-get-clue_f="(clueIndex, cb_f) => {m_clickGetClue_f(currentRiddleIndex_n, clueIndex, cb_f)}"
                :p_click-skip-riddle_f="(unlocksData_byLockId, cb_f)=> {m_clickSkipRiddle_f(currentRiddleIndex_n, unlocksData_byLockId, cb_f)}"
                :pe_rs_unlock-data_update_f="m_updateRiddleLock_f"/>
        </tq-card>

        <div v-else class="TQ_center">
            <ball-pulse-sync-loader color="#2E294E" size="10px"/>
        </div>

    </div>
</template>

<script>
import {
    enum_finishQuest_s,
    enum_mapMissionsTypes,
    enum_subCollection_teamStatus
} from "../../../../functions/src/shareCode/Share_S_Enum";
    import {store_var, store_getStateValue_vo, store_setStateValue} from "../../../store";
    import {
        route_moveToRoute,
        route_getUrlParams,
        route_currentPath_s
    } from "../../../router";
    import {
        serverOngoing_teamPlayersGeoLocation_cl_set_f,
        serverOngoing_teamPlayersGeoLocation_cl_remove_f,
        serverOngoing_teamStatus_subCollection_cl_get_f,
        serverOngoing_teamStatus_subCollection_cl_remove_f,
        serverOngoing_teamStatusSub_riddleStatus_unlockData_update_f,
        serverOngoing_teamStatus_riddleStatus_useClue_update_f,
        serverOngoing_teamStatusSub_riddleStatus_useSkip_f,
        serverOngoing_teamStatus_vl_set_f,
        serverOngoing_teamStatus_vl_remove_f,
    } from "../../../scripts/Server/S_ServerOngoing";
    import {
        serverAuth_getOtherUserData_f
    } from "../../../scripts/Server/S_ServerAuth";
    import {serverBig_questBody_once_fp} from "../../../scripts/Server/S_ServerFirestore";
    import TqRiddleData from "../../../components/complex/TqRiddleData";
    import TqCard from "../../../components/basic/TqCard";
    import {
        enum_moveToOptions,
        enum_serverRequestType,
        enum_urlParams
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f
    } from "../../../scripts/Server/S_ServerAuth";
    import {helper_finishAllRiddle_fb, helper_finishRiddle_fb} from "../../../scripts/S_Helper";
import {FB_MapPlayerLocation} from "@/classes/client_classes";

    export default {
        name        : "V_Ongoing_Quest_OpenMap_Riddle",
        components  : {
            TqCard,
            TqRiddleData,
        },
        props:{
            pe_startWatchPosition_f:{
                type: Function,
                require: true
            },
            pe_stopWatchPosition_f:{
                type: Function,
                require: true
            }
        },
        data() {
            return {

                currentRiddleIndex_n               : null,

                // store
                store_system_langCode_ve        : store_getStateValue_vo(store_var.system_langCode),
                store_currentUserGeoLocation_vc : store_getStateValue_vo(store_var.system_currentUserLocation),
                store_questEvent_c              : store_getStateValue_vo(store_var.ongoing_questEvent).val,
                store_currentTeamId_uid         : store_getStateValue_vo(store_var.ongoing_currentTeamId_uid).val,
                store_system_windowSizeType_ve  : store_getStateValue_vo(store_var.system_windowSizeType_e).val,

                // server
                server_teamStatus_c               : undefined,
                server_currentUserData_c          : undefined,
                server_questBody_c                : undefined,
                server_ts_riddles_byRiddleId_c    : {},
                server_mapPlayerLocation_byUserId_c : {},

                enum_subCollection_teamStatus: enum_subCollection_teamStatus
            }
        },
        computed:{
            co_qb_displayLangCode_e(){
                return this.server_questBody_c.cm_qb_getDisplayLangCode_e(this.store_system_langCode_ve.val)
            },
            co_currentUserLocation_c(){
                if(this.server_currentUserData_c.ud_userId_uid == null || this.store_currentUserGeoLocation_vc.val == null){
                    return null
                }

                return new FB_MapPlayerLocation({
                    mpl_userId_uid      : this.server_currentUserData_c.ud_userId_uid,
                    mpl_username_s      : null,
                    mpl_dotColor_s      : "#4285F4",
                    mpl_accuracy_n      : this.store_currentUserGeoLocation_vc.val.ugl_accuracy_n,
                    mpl_latitude_n      : this.store_currentUserGeoLocation_vc.val.ugl_latitude_n,
                    mpl_longitude_n     : this.store_currentUserGeoLocation_vc.val.ugl_longitude_n,
                    mpl_timestamp_t     : this.store_currentUserGeoLocation_vc.val.ugl_timestamp_t,
                    mpl_secondsForOld_n : 5,
                })
            },

            co_currentRiddleIsLast_b(){

                // support map last riddles
                if(this.server_questBody_c.qb_metadata_c.qbm_quest_supportMapLastMissions_b){
                    return false
                }


                if(this.server_questBody_c.qb_metadata_c.qbm_quest_finishQuest_e === enum_finishQuest_s.mapMissions_finishAll){
                    return helper_finishAllRiddle_fb(this.server_questBody_c.qb_mapMissions_ac, this.server_ts_riddles_byRiddleId_c)
                }

                // route map last riddle
                if(this.server_questBody_c.qb_metadata_c.qbm_mapMissions_missionsType_e === enum_mapMissionsTypes.markers_route){
                    return  this.currentRiddleIndex_n+1 === this.server_questBody_c.qb_mapMissions_ac.length
                }

                return false
            }
        },
        methods: {
            m_clickImg_f(imgSrc_s){
                store_setStateValue(store_var.ongoing_fullScreenImage_s, imgSrc_s)
            },
            m_clickGetClue_f(riddleIndex_n, clueIndex_n, cb_f) {

                serverOngoing_teamStatus_riddleStatus_useClue_update_f({
                    questEvent_c: this.store_questEvent_c,
                    teamId_uid  : this.store_currentTeamId_uid,
                    userId_uid  : this.server_currentUserData_c.ud_userId_uid,
                    teamStatus_subCollection_e: enum_subCollection_teamStatus.MAP_MISSIONS,
                    riddleData_c: this.server_questBody_c.qb_mapMissions_ac[riddleIndex_n],
                    teamStatus_c: this.server_teamStatus_c,

                    clueId_n    : clueIndex_n,
                    clueMode_e  : this.server_questBody_c.qb_metadata_c.qbm_missions_cluesMode_e,
                    cb_f : cb_f
                })
            },
            m_clickSkipRiddle_f(riddleIndex, unlocksData_byLockId, cb_f) {

                let riddle_c = this.server_questBody_c.qb_mapMissions_ac[this.currentRiddleIndex_n]

                serverOngoing_teamStatusSub_riddleStatus_useSkip_f({
                    questEvent_c: this.store_questEvent_c,
                    teamId_uid: this.store_currentTeamId_uid,
                    teamStatus_subCollection_e: enum_subCollection_teamStatus.MAP_MISSIONS,
                    riddleId_n: this.server_questBody_c.qb_mapMissions_ac[riddleIndex].qbr_riddleId_n,
                    unlocksData_byLockId: unlocksData_byLockId,

                    finishRiddle_fb              : () => {
                        let rs_riddle_c = this.server_ts_riddles_byRiddleId_c[riddle_c.qbr_riddleId_n]
                        return helper_finishRiddle_fb(riddle_c, rs_riddle_c)
                    },
                    lastRiddle_fb : () => this.co_currentRiddleIsLast_b,

                    cb_f : cb_f
                })

            },
            m_updateRiddleLock_f(lockIndex_n, rs_unlocksData_c, cb_f) {

                let riddle_c = this.server_questBody_c.qb_mapMissions_ac[this.currentRiddleIndex_n]

                serverOngoing_teamStatusSub_riddleStatus_unlockData_update_f({
                    questEvent_c: this.store_questEvent_c,
                    teamId_uid: this.store_currentTeamId_uid,
                    userId_uid: this.server_currentUserData_c.ud_userId_uid,
                    teamStatus_subCollection_e: enum_subCollection_teamStatus.MAP_MISSIONS,

                    lockIndex_n                 : lockIndex_n,
                    riddleData_c                : this.server_questBody_c.qb_mapMissions_ac[this.currentRiddleIndex_n],
                    rs_lockData_c               : rs_unlocksData_c,

                    questSupportPoints_b        : this.server_questBody_c.qb_metadata_c.qbm_missions_supportMissionsPoints_b,

                    questLastRiddle_b           : this.co_currentRiddleIsLast_b,
                    riddleStatus_c              : this.server_ts_riddles_byRiddleId_c[riddle_c.qbr_riddleId_n],

                    cb_f : (setData_b) => {
                        cb_f(setData_b)
                    }
                })

            }
        },

        // ===== life circle =====
        created(){





            // 1) get currentUserData
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData) => {
                this.server_currentUserData_c = currentUserData;
            })

         

            // 2) get teamStatus
            serverOngoing_teamStatus_vl_set_f({
                viewName_s: this.$options.name, 
                questEvent_c : this.store_questEvent_c, 
                teamId_uid : this.store_currentTeamId_uid,
                cb_f: (teamStatus_c) => {
                    this.server_teamStatus_c = teamStatus_c;
                }
            })
 
            // 3) get teamStatus subCollection riddles
            serverOngoing_teamStatus_subCollection_cl_get_f({
                viewName_s: this.$options.name,
                subCollectionName_e: enum_subCollection_teamStatus.MAP_MISSIONS,
                questEvent_c: this.store_questEvent_c,
                teamId_uid: this.store_currentTeamId_uid,
                cb_ChildAdded_f : (riddleStatus_c) => {
                    this.$set(this.server_ts_riddles_byRiddleId_c, riddleStatus_c.rs_riddleId_n, riddleStatus_c)
                },
            })

            // 4) questBody
            serverBig_questBody_once_fp(this.store_questEvent_c.qev_questType_e, this.store_questEvent_c.qev_questId_uid, false, true, (questBody_c)=>{
                this.server_questBody_c = questBody_c
            })

            // 5) teamPlayerGeoLocations
            serverOngoing_teamPlayersGeoLocation_cl_set_f(this.$options.name, this.store_questEvent_c, this.store_currentTeamId_uid,
                (userGeoLocation_c) => {


                    // not location of currentUser
                    if( this.server_currentUserData_c != null &&
                        this.server_currentUserData_c.ud_userId_uid !== userGeoLocation_c.ugl_userId_uid){

                        // get current user
                        serverAuth_getOtherUserData_f(userGeoLocation_c.ugl_userId_uid, userData_c => {

                            this.$set(this.server_mapPlayerLocation_byUserId_c, userGeoLocation_c.ugl_userId_uid, new FB_MapPlayerLocation({
                                mpl_userId_uid      : userGeoLocation_c.ugl_userId_uid,
                                mpl_username_s      : userData_c.ud_name_s,
                                mpl_dotColor_s      : "green",
                                mpl_accuracy_n      : userGeoLocation_c.ugl_accuracy_n,
                                mpl_latitude_n      : userGeoLocation_c.ugl_latitude_n,
                                mpl_longitude_n     : userGeoLocation_c.ugl_longitude_n,
                                mpl_timestamp_t     : userGeoLocation_c.ugl_timestamp_t,
                                mpl_secondsForOld_n : 5,
                            }))

                        })
                    }
                })

        },
        activated(){
            this.currentRiddleIndex_n = parseInt(route_getUrlParams(this.$route,enum_urlParams.riddleId_n))

            // TODO : check when lazy load working here
            if(route_currentPath_s(this.$route).includes(enum_moveToOptions.ongoing_quest_openMap_map)){
                route_moveToRoute(enum_moveToOptions.ongoing_quest_openMap_riddle)
            }

        },
        destroyed(){
            // 1) current user
            serverAuth_currentUserData_remove_vl_f(this.$options.name)

            // 2) team status
            serverOngoing_teamStatus_vl_remove_f(this.$options.name, this.store_questEvent_c, this.store_currentTeamId_uid)

            // 3) teamStatus subCollection riddles
            serverOngoing_teamStatus_subCollection_cl_remove_f({
                viewName_s          : this.$options.name,
                subCollectionName_e : enum_subCollection_teamStatus.MAP_MISSIONS,
                questEvent_c        : this.store_questEvent_c,
                teamId_uid          : this.store_currentTeamId_uid,
            })

            // 4) remove teamPlayerGeoLocation listener
            serverOngoing_teamPlayersGeoLocation_cl_remove_f(this.$options.name, this.store_questEvent_c, this.store_currentTeamId_uid)



        },

    }
</script>

<style scoped lang="scss">
    .root{
        height: 100%;
    }
</style>